
import React, { useEffect } from "react";
import { Col, FormControl, FormLabel, Row, } from "react-bootstrap";

interface Data {
  data: any;
}

const AdicionarProdutoData: React.FC<Data> = ({ data }) => {

  return (
    <Row className="d-flex align-items-center justify-content-center">
      <Col lg={9} md={9} xs={12} className="mt-3">
        <FormLabel>DESCRIÇÃO</FormLabel>
        <FormControl type="text" disabled value={data?.descricao ?? "-"} />
      </Col>
      <Col lg={3} md={3} xs={12} className="mt-3">
        <FormLabel>Unidade</FormLabel>
        <FormControl type="text" disabled value={data?.unidade ?? "-"} />
      </Col>
      <Col lg={6} md={6} xs={12} className="mt-3">
        <FormLabel>Grupo</FormLabel>
        <FormControl type="text" disabled value={data?.grupo ?? "-"} />
      </Col>
      <Col lg={3} md={3} xs={12} className="mt-3">
        <FormLabel>Gênero</FormLabel>
        <FormControl type="text" disabled value={data?.genero ?? "-"} />
      </Col>
      <Col lg={3} md={3} xs={12} className="mt-3">
        <FormLabel>Cor</FormLabel>
        <FormControl type="text" disabled value={data?.cor ?? "-"} />
      </Col>
    </Row>
  );
};

export default AdicionarProdutoData;
